import React from "react";
import { observer } from "mobx-react-lite";
import { useTranslation } from "react-i18next";
import { useEditorStore } from "../../store/editorStore";

/**
 * Bottom hint shown when wall mode was started from the hover "+".
 * Yellow chip with black text — Press Esc to exit wall mode.
 */
const WallConstructionEscHint: React.FC = observer(() => {
  const { t } = useTranslation();
  const editorStore = useEditorStore();

  if (!editorStore.wallConstructionMode || !editorStore.wallConstructionFromHoverAdd) {
    return null;
  }

  return (
    <div className="pointer-events-none absolute bottom-8 left-1/2 z-[9998] max-w-xl -translate-x-1/2">
      <div className="rounded-lg border border-black/15 bg-boniYellowPrimary px-5 py-3 text-sm font-semibold text-black shadow-md">
        <span>
          {t("construction.press")}{" "}
          <kbd className="rounded border border-black/25 bg-white px-2 py-1 font-mono text-xs font-bold leading-none text-black shadow-sm">
            {t("construction.esc")}
          </kbd>{" "}
          {t("construction.wallEscHint")}
        </span>
      </div>
    </div>
  );
});

export default WallConstructionEscHint;
